/*前端鉴权统一方法*/
import axios from "axios";
import { getRequestSign } from 'lib/tools/platformSign'
import { getPlatform } from 'lib/tools/getPlatform'
const { yixinliAPPVersion } = getPlatform()

const baseParams = {
  _version: '6.7.7',
  _platform: 'm'
}

export const yiapiRequestGet = (api, params) => {
  let _params = Object.assign({}, baseParams, params)
  let platFormSign = getRequestSign(_params)

  return axios.get(api, {
    params: Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
  })
}

export const yiapiRequestPost = (api, params) => {
  let _params = Object.assign({}, {
    _version: yixinliAPPVersion
  }, params)
  let platFormSign = getRequestSign(_params)

  return axios.post(api,
    Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
  )
}
